<template>
    <div>
        <h1>Update Your Profile</h1>
        <div v-if="isSuccess">
            <p>Your profile has been updated.</p>
        </div>
        <ul v-if="errors.length" class="error">
            <li v-for="error in errors" v-bind:key="error">
                {{ error }}
            </li>
        </ul>
        <form
            @submit.prevent="updateProfile"
            accept-charset="UTF-8"
            v-if="isInitial || isSaving || isFailed || isSuccess"
            novalidate="true"
        >
            <div>
                <label for="first-name">
                    First Name*
                </label>
                <input
                    v-model="firstName"
                    type="text"
                    id="first-name"
                    name="firstName"
                    value
                />
            </div>

            <div>
                <label for="last-name">
                    Last Name*
                </label>
                <input
                    v-model="lastName"
                    type="text"
                    id="last-name"
                    name="lastName"
                    value
                />
            </div>

            <div>
                <label for="email">
                    Email*
                </label>
                <input v-model="email" type="email" name="email" value />
            </div>

            <div>
                <label for="country">Country</label>
                <select id="country" v-model="country">
                    <option value="">Select Country</option>
                    <option
                        v-for="country in countryOptions"
                        v-bind:key="country.key"
                        :value="country.key"
                    >
                        {{ country.value }}
                    </option>
                </select>
            </div>

            <div
                v-if="
                    country == 'USA' ||
                        country == 'Mexico' ||
                        country == 'Canada'
                "
            >
                <label for="city">City</label>
                <input v-model="city" type="text" id="city" name="city" value />
            </div>

            <div
                v-if="
                    country == 'USA' ||
                        country == 'Mexico' ||
                        country == 'Canada'
                "
            >
                <label for="state-province">State or Province</label>
                <select id="state-province" v-model="stateProvince">
                    <option value="">Select State or Province</option>
                    <option
                        v-for="stateProvince in stateProvinceOptions"
                        v-bind:key="stateProvince.key"
                        :value="stateProvince.key"
                    >
                        {{ stateProvince.value }}
                    </option>
                </select>
            </div>

            <div
                v-if="
                    country == 'USA' ||
                        country == 'Mexico' ||
                        country == 'Canada'
                "
            >
                <label for="zip-code">Zip/Postal Code</label>
                <input
                    v-model="zipPostalCode"
                    type="text"
                    id="zip-code"
                    name="zipPostalCode"
                    value
                />
            </div>

            <!--
            <div>
                <label for="educator">
                    I am an educator
                    <input v-model="educator" type="checkbox" id="educator" />
                </label>
            </div>

            <div v-if="educator">
                <div>
                    <label for="educator-grade">
                        Which grade do you teach?
                    </label>
                    <select id="educator-grade" v-model="educatorGrade">
                        <option value="99" selected>Select Grade</option>
                        <option value="0" selected>
                            Pre-K or Kindergarten
                        </option>
                        <option
                            v-for="index in 12"
                            v-bind:key="index"
                            :value="index"
                        >
                            {{ index }}
                        </option>
                    </select>
                </div>
                <div>
                    <label for="number-students">
                        Estimated number of participating students
                    </label>
                    <input
                        v-model="educatorNumberStudents"
                        type="text"
                        id="number-students"
                        name="educatorNumberStudents"
                        value
                    />
                </div>
                <div>
                    <label for="school-name">Name of school</label>
                    <input
                        v-model="educatorSchoolName"
                        type="text"
                        id="school-name"
                        name="educatorSchoolName"
                        value
                    />
                </div>
                <div>
                    <label for="school-comments">
                        Comments? Describe your goals
                    </label>
                    <input
                        v-model="educatorComments"
                        type="text"
                        id="school-comments"
                        name="educatorSchoolComments"
                        value
                    />
                </div>
            </div>
            -->

            <div>
                <button type="submit" name="button">Update</button>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios'

const STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3

// let fd = new FormData()

// const dateArray = new Date()
//     .toISOString()
//     .slice(0, 10)
//     .split('-')

export default {
    data() {
        return {
            customerId: 0,
            email: '',
            firstName: '',
            lastName: '',
            password: '',
            passwordConfirm: '',
            country: '',
            countryOptions: [],
            city: null,
            stateProvince: null,
            stateProvinceOptions: [],
            zipPostalCode: '',
            educator: false,
            educatorGrade: null,
            educatorNumberStudents: 0,
            educatorSchoolName: '',
            educatorComments: '',
            errors: [],
            currentStatus: null
        }
    },
    created() {
        this.reset()

        const user = this.$store.state.user

        this.customerId = user.customerId
        this.email = user.email
        this.firstName = user.firstName
        this.lastName = user.lastName
        this.country = user.country
        this.city = user.city
        this.stateProvince = user.stateProvince
        this.zipPostalCode = user.zipPostalCode
        this.educatorGrade = user.educatorGrade
        this.educatorNumberStudents = user.educatorNumberStudents
        this.educatorSchoolName = user.educatorSchoolName
        this.educatorComments = user.educatorComments
        if (
            user.educatorGrade != 99 ||
            user.educatorNumberStudents.length ||
            user.educatorSchoolName.length ||
            user.educatorComments.length
        )
            this.educator = true

        axios
            .get(process.env.VUE_APP_API_DOMAIN + '/countries')
            .then(({ data }) => {
                this.countryOptions = data.countries
            })

        axios
            .get(process.env.VUE_APP_API_DOMAIN + '/states')
            .then(({ data }) => {
                this.stateProvinceOptions = data.states
            })
    },
    computed: {
        isInitial() {
            return this.currentStatus === STATUS_INITIAL
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED
        }
    },
    methods: {
        reset() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL
        },
        updateProfile() {
            this.currentStatus = STATUS_SAVING
            this.errors = []
            if (this.firstName.length < 2) {
                this.errors.push('First Name is a required field.')
            }
            if (this.lastName.length < 2) {
                this.errors.push('Last Name is a required field.')
            }
            if (this.email.length < 7) {
                this.errors.push('Email is a required field.')
            }
            if (!this.validEmail(this.email)) {
                this.errors.push('Please enter a valid email address.')
            }
            if (this.errors.length > 0) {
                return false
            }
            this.$store
                .dispatch('profileUpdate', {
                    customerId: this.customerId,
                    email: this.email,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    country: this.country,
                    city: this.city,
                    stateProvince: this.stateProvince,
                    zipPostalCode: this.zipPostalCode,
                    educatorGrade: this.educatorGrade,
                    educatorNumberStudents: this.educatorNumberStudents,
                    educatorSchoolName: this.educatorSchoolName,
                    educatorComments: this.educatorComments
                })
                .then(() => {
                    this.currentStatus = STATUS_SUCCESS
                })
                .catch(err => {
                    this.errors.push(err.response.data.message)
                    this.currentStatus = STATUS_FAILED
                })
        },
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(email)
        }
    }
}
</script>

<style scoped>
form > div {
    margin-bottom: 1em;
}
label {
    display: block;
}
</style>
